import { useState, useEffect } from 'react';

type SidebarState = {
  desktopOpen: boolean;
  mobileOpen: boolean;
};

// Module-level state shared across all components without needing a Context provider
let state: SidebarState = { desktopOpen: true, mobileOpen: false };
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((fn) => fn());
}

export const sidebarActions = {
  toggleDesktop() {
    state = { ...state, desktopOpen: !state.desktopOpen };
    notify();
  },
  openMobile() {
    state = { ...state, mobileOpen: true };
    notify();
  },
  closeMobile() {
    state = { ...state, mobileOpen: false };
    notify();
  },
  toggleMobile() {
    state = { ...state, mobileOpen: !state.mobileOpen };
    notify();
  },
};

export function useSidebarStore() {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const fn = () => forceUpdate((n) => n + 1);
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }, []);

  return {
    desktopOpen: state.desktopOpen,
    mobileOpen: state.mobileOpen,
    ...sidebarActions,
  };
}
